<template>
  <d2-container>
    <top-line :message="pageTitle" :iconclass="'fa fa-users'"></top-line>
    <div class="pagebody">
      用户余额 : <span>{{ balanceCost }} </span> 元
    </div>

    <div class="chartDay">
      <h1 class="c-satwo">日账单 </h1>
        <line-chart-component :chart-data="formattedChartData"  v-if="dataLoaded"></line-chart-component>
    </div>

    <div class="chartDay chartMonth">
      <h1 class="c-satwo">月账单 </h1>
        <BarChart :chart-data="barChartData" />
    </div>

  </d2-container>
</template>

<script>

import topLine from "@/components/save-common/topLine.vue";
import commonListMixin from "@/pages/mixin/mixin-common-list";
import util from '@/libs/util.js'
import LineChartComponent from './LineChartComponent.vue';
import BarChart from './BarChart.vue'

export default {
  name: "allns",
  mixins: [
    commonListMixin
  ],
  components: {
    topLine,
    LineChartComponent,
    BarChart,
  },
  data() {
    return {
      pageTitle: "集群用户用量计费",
      labelWidth: '120px',
      balanceCost: '',
      formattedChartData: {
        xAxisData: [],
        seriesData: []
      },
      dataLoaded: true,
      barChartData: {
        labels: [],
        datasets: []
      }
    }
  },
  computed: {
  },
  mounted () {
    this.initDate()
    this.fetchChartData();
    this.monthfetchChartData();
  },
  methods: {
    initDate() {
      this.$axios.get('/api/user-balance')
        .then(res => {
          this.balanceCost = res.data[0].balance
        }).catch(err => {
          console.log(err)
        })
    },

    getRecentDates() {
      const today = new Date();
      const yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - 1); // 昨天

      const sevenDaysAgo = new Date(today);
      sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7); // 7天前

      const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };

      return {
        start_time: formatDate(sevenDaysAgo),
        end_time: formatDate(yesterday)
      };
    },

    async fetchChartData() {
      try {
        const { start_time, end_time } = this.getRecentDates();

        const response = await this.$axios.get('/api/day-line', {
          params: {
            username: util.cookies.get('username'),
            start_time,
            end_time
          }
        });
        const resData = response;
        // 处理数据
        this.formattedChartData.xAxisData = resData.xAxisData || [];

        // 注意：这里要包装成 ECharts 需要的 series 格式
        this.formattedChartData.seriesData = [
          {
            name: '日账单',
            type: 'line',
            data: resData.seriesData
          }
        ];

        this.dataLoaded = true;

      } catch (error) {
        console.error('请求数据失败:', error);
        this.dataLoaded = true;
      }
    },

    getLastFiveMonthsRange() {
      const today = new Date();

      // 设置 end_time 为当前月份的最后一天
      const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      const end_month = `${endOfMonth.getFullYear()}-${String(endOfMonth.getMonth() + 1).padStart(2, '0')}`;

      // 设置 start_time 为往前推 5 个月的第一天
      let startMonth = today.getMonth() - 5;
      let startYear = today.getFullYear();
      if (startMonth < 0) {
        startMonth += 12;
        startYear -= 1;
      }
      const start_month = `${startYear}-${String(startMonth + 1).padStart(2, '0')}`;

      return {
        start_month,
        end_month
      };
    },

    async monthfetchChartData() {
      try {
        const { start_month, end_month } = this.getLastFiveMonthsRange();

        const response = await this.$axios.get('/api/mouth-line', {
          params: {
            username: util.cookies.get('username'),
           // username:'ahigpu',
            start_month,
            end_month
          }
        });

        const resData = response;

        this.barChartData.labels = resData.xAxisData || [];
        this.barChartData.datasets = [
          {
            label: '月账单',
            type: 'bar',
            data: resData.seriesData || []
          }
        ];

      } catch (error) {
        console.error('请求数据失败:', error);
      }
    }
    
  }

}
</script>

<style scoped lang="scss">
.pagebody {
  margin-top: 20px;
  margin-left: 50px;
  font-size: 20px;
  padding-bottom: 70px;
}
.pagebody span{
  font-size: 26px;
}
.chartDay{
  width:40%; 
  float:left; 
  margin-left: 10%
}
.chartMonth{
  width:45%; 
  float:left;
  margin-left: 5%
}
.c-satwo{
    font-size: 20px;
    margin-left: 37px;
    position: relative;
    top: 40px;
}
</style>
